import { BackupPolicyType } from '@repo/api-gw-sdk';

import type { StepProps } from '@/components/wizard/StepProps';

import type { BackupPolicyEditState } from './BackupPolicyCreationFlow';
import { BackupPolicySettingsNativePitr } from './BackupPolicySettingsNativePitr';
import { BackupPolicySettingsPitr } from './BackupPolicySettingsPitr';
import { BackupPolicySettingsStandard } from './BackupPolicySettingsStandard';
import { isContinuousPolicyType } from './backupPoliciesTypes';

export const BackupPolicySettings = (
  props: StepProps<BackupPolicyEditState>
) => {
  return props.wizardState.policyType ===
    BackupPolicyType.BACKUP_POLICY_TYPE_PITR ? (
    <BackupPolicySettingsPitr {...props} />
  ) : isContinuousPolicyType(props.wizardState.policyType) ? (
    <BackupPolicySettingsNativePitr {...props} />
  ) : (
    <BackupPolicySettingsStandard {...props} />
  );
};
